<template>
  <line
    id="inlet"
    :x1 ="getInletPosition + getXAxisGap"
    :y1 = "0"
    :x2 = "getInletPosition + getXAxisGap"
    :y2 = "getLineHeight - 13"
    class="inlet-line"
  />
<!--  <line
    :x1 ="0"
    :y1 = "getHorizontalInletLine"
    :x2 = "getInletPosition + getXAxisGap"
    :y2 = "getHorizontalInletLine"
    class="inlet-line"
  />-->
  <rect
    id="inletArea"
    :x = "getInletPosition - radius"
    :y = "0"
    :width = "Math.max(radius * 2, 0)"
    :height = "transformYOffset + 18"
    fill = "rgba(0,0,255,.0)"
    pointer-events="visible"
    class="inlet-circle"
    @mousedown="handleMouseDown"
    @touchstart="handleMouseDown"
  />
</template>

<script>
import { useSegmentStore } from '@/store/SegmentStore';
import { useInputStore } from '@/store/InputStore';
import { nextTick } from 'vue';
import {usePrintStore} from '@/store/PrintStore';

export default {
  name: 'Inlet',
  data () {
    return {
      x1: 0,
      y1: 120,
      x2: 200,
      y2: 120,
      startCircleX : 0,
      startMouseX: 0,
      radius: 20
    };
  },
  mounted () {
    useSegmentStore().setInletComponent(this);
  },
  computed: {
    getInletPosition () {
      return useSegmentStore().getScaledInletPosition;
    },
    transformYOffset () {
      return useSegmentStore().getPipeEditorHeight * .5;
    },
    getLineHeight () {
      return this.transformYOffset + this.getYOffset;
    },
    getYOffset () {
      return useSegmentStore().getInletPositionY;
    },
    getXAxisGap () {
      return 0;
    },
    getHorizontalInletLine () {
      let startingY = this.transformYOffset * .8;
      let inletY = this.getYOffset - 25;
      return startingY + inletY;
    }
  },
  methods: {
    handleMouseDown (e) {
      
      if (usePrintStore().getPrintIsOpen) {
        return;
      }
      
      if (e.touches) { e = e.touches[0]; }
      this.startCircleX = useSegmentStore().getScaledInletPosition - useInputStore().getXAxisGap;
      this.startMouseX = e.clientX;
      if (e.radiusX) {
        window.addEventListener('touchmove', this.handleMouseMove);
        window.addEventListener('touchend', this.handleMouseUp);
      } else {
        window.addEventListener('mousemove', this.handleMouseMove);
        window.addEventListener('mouseup', this.handleMouseUp);
      }
    },
    handleMouseMove (e) {
      if (e.touches) { e = e.touches[0]; }
      const segmentStore = useSegmentStore();
      let newPosition = (e.clientX - this.startMouseX + this.startCircleX) / segmentStore.getMagScale; 
      if (newPosition < 0 ) { newPosition = 0; }
      // this is the max if the end of the last pipe is as far as the last inlet can go
      let max = segmentStore.getAllSegmentLengths('pipe');
      if (newPosition > max) { newPosition = max; }
      segmentStore.setInletPosition(newPosition);
    },
    handleMouseUp (e) {
      useSegmentStore().splitInlet();
      nextTick(() => { useInputStore().sprinklerCalc(); });
      if (e.touches) {
        window.removeEventListener('touchmove', this.handleMouseMove);
        window.removeEventListener('touchend', this.handleMouseUp);
      } else {
        window.removeEventListener('mousemove', this.handleMouseMove);
        window.removeEventListener('mouseup', this.handleMouseUp);
      }
    }
  }
};
</script>

<style scoped>
.inlet-circle {
  cursor: ew-resize;
}
.inlet-line {
  stroke:var(--inlet);
  stroke-width:3;
}
</style>